import apiHandler from '../../utilities/apiHandler.js';

const InvoiceControlApiHandler = {

	getPODDetails: function (orderId) {
		var URL = "inwarding/rpo?orderId=" + orderId;
        return apiHandler.get(URL);
    },

    createInwardingDocument: function(request) {
    	var URL = "v2/inwarding/inwarding-document/create";
    	return apiHandler.post(URL, request);
    }
}



export default InvoiceControlApiHandler


// WEBPACK FOOTER //
// ./src/screens/InvoiceControl/InvoiceControlApiHandler.js